import { httpRequest } from "@services/http"

export type LaunchNetworkPolicyPayload = {
  network: string
  percent: number
  margin?: number
  daily_spend_cap?: number | null
  bid?: number | null
  name?: string
}

export class CommandUpsertLaunchNetworkPolicy {
  async run(launchId: number, data: LaunchNetworkPolicyPayload): Promise<void> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/engagements/launches/${launchId}/policies/budget/`
    await httpRequest(url, { method: "POST", body: data })
  }
}
